export const companySelector = (state) => state.company
